import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-router-dom";
import { useState } from "react";
import { Grid } from "react-loading-icons"

function YesNoAsk_Modal({
  coursesetBaseOnMajor,
  setReload,
  disabled,
  reload,
  handleClose,
  setStatusNode,
  setNoteNode,
  date,
  htmlDivElement,
  title,
  show,
  setShow,
  btnName,
  variant,
  execFunc,
  submitFunc,
  submitCounter,
  responseMessage,
  bodyMessage,
  studentId,
}) {
  let [click, setClick] = useState(false);

  return (
    <div className="">
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header className="bg-danger" closeButton>
          <Modal.Title className="text-white">{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {htmlDivElement}
          {bodyMessage}
          <br />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            disabled={disabled || click ? true : false}
            onClick={async function () {
              setClick(true);

              if (!submitCounter) submitFunc();
              else await execFunc();

              setClick(false);

              // check if setReload function exist then update increment the reload value, to reload the attends_show page. for the advisor.
              if (setReload) {
                setReload((e) => e + 1);
              }
            }}
            variant={variant}
          >
            {btnName}

            {disabled ?
              <span>
                &nbsp;
                <Grid />
              </span> : ''
            }

          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default YesNoAsk_Modal;
